import structureTypes from 'common/constants/structureTypes'
import React from 'react'
import ButtonSettings from './entities/ButtonSettings'
import InputSettings from './entities/input-settings'
import LanguageSwitcherSettings from './entities/LanguageSwitcherSettings'
import PaymentButtonSettings from './entities/PaymentButtonSettings'
import PaymentMethodSettings from './entities/PaymentMethodSettings'
import RowSettingsOld from './entities/RowSettingsOld'
import SectionSettingsOld from './entities/SectionSettings/SectionSettingsOld'
import StartTimerSettings from './entities/StartTimerSettings'

export default {
  create(type, id, props) {
    let component = null
    switch (type) {
      case structureTypes.SECTION:
        component = SectionSettingsOld
        break
      case structureTypes.ROW:
        component = RowSettingsOld
        break
      case structureTypes.BUTTON:
        component = ButtonSettings
        break
      case structureTypes.FORM_INPUT:
        component = InputSettings
        break
      case structureTypes.PAYMENT_BUTTON:
        component = PaymentButtonSettings
        break
      case structureTypes.START_TIMER:
        component = StartTimerSettings
        break
      default:
        component = ''
    }

    return React.createElement(component, props)
  },
}
